import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import "./item.css";
const StyledBadge = withStyles(theme => ({
  badge: {
    top: "50%",
    right: -1,
    // The border color match the background color.
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`
  }
}))(Badge);

export default function CustomizedBadges(props) {
  return (
    <IconButton aria-label="Cart" onClick={props.Click} style={{ padding: 0 }}>
      <StyledBadge badgeContent={props.count} color="secondary">
        <ShoppingCartIcon style={{ color: "white" }} id="cart" />
      </StyledBadge>
    </IconButton>
  );
}
